import axios from 'axios';
import * as _ from 'lodash'

class AccountService {
  /**
   * Retorna o endereco de correspondencia do usuario
   *
   * @returns Promise<Object> endereco
   */
  getAddressMailing(moveMaisId) {
    return (
      axios
        // .get(`/v1/getAddress/${moveMaisId}`)
        .get(`/v2/getAddressByMoveMaisId/${moveMaisId}`)
        .then((res) => {
          let address = _.find(res.data.address, function (o) {
            return o.type == "MAILING";
          });
          return address;
        })
    );
  }

  /**
   * Retorna uma lista com os endereços do usuário
   *
   * @returns Promise<Object> endereco
   */
  getAddressDeliveryList(moveMaisId) {
    return axios.get(`/v2/getAddressByMoveMaisId/${moveMaisId}`).then((res) => {
      let address = _.filter(res.data.address, function (o) {
        return o.type == "DELIVERY";
      });
      return address;
    });
  }

  /**
   * Atualiza os dados do usuario
   *
   * @returns Promise<Object> status da resposta
   */
  updateUser(user) {
    // if(user.type == "PESSOA_FISICA"){
    //   user.type = 1;
    // }else{
    //   user.type = 2;
    // }
    if(user.active == null){
      user.active = 0;
    }
    return axios
      .post('/v2/updateUser', {account: user});

  }

  /**
   * Atualiza os dados de endero do usuario
   *
   * @returns Promise<Object> status da resposta
   */
  updateAddress(address) {
    return axios.post("/v2/updateAddress", { address: address });
  }

  /**
   * Atualiza os dados de endero do usuario
   *
   * @returns Promise<Object> status da resposta
   */
  insertAddress(address) {
    return axios.post("/v2/insertAddress", { address: address });
  }

  /**
   * Consulta de CEP
   *
   * @returns Promise<Object> ZipCode
   */
  queryAddress(zipCode){
    zipCode = zipCode.replace(/[^0-9]/g, '');
    return axios
      .get(`/v2/queryAddress/${zipCode}`, {zipCode: zipCode})
      .then(res => {
        return res.data.address.zipCode;
      })
  }

  accountExists(obj){
    let url;
    if (obj.email)
      url = `/v2/accountExists?email=${obj.email}`;

    if (obj.taxIdNumber)
      url = `/v2/accountExists?taxIdNumberCPF=${obj.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase()}`;

    return axios.get(url)
      .then(r => true).catch(err => {
        if(err.response.status == 488)
          return false;

        //retorna true se nao consegui validar para nao bloquear o cadastro
        return true;
      });
  }

  getListChildAccount(moveMaisId) {
    return axios.get(`/v2/getListChildAccount/${moveMaisId}`).then((res) => {
      return (
        res.data.childAccountList && res.data.childAccountList.childAccount
      );
    });
  }

  getUserSimple(taxId){
    return axios
      .get(`/v2/getUserSimple/${taxId}`).then(res => {
        return res.data;
      });
  }

  getContractByTaxPayerId(taxPayerId) {
    return axios
    .get(`/v2/getContractByTaxPayerId/${taxPayerId}`).then(res => {
      return res.data.response;
    });
  }

  getContractByTaxPayerIdSite(taxPayerId,contractId) {
    return axios
    .get(`/v2/getContractByTaxPayerIdSite/${taxPayerId}/${contractId}`).then(res => {
      return res.data.response;
    });
  }

  getNotification() {
    return axios
      .post(`/v2/getNotification`, {})
      .then(res => {
        return res.data.notifications.notification;
      })
  }

  upSertNotification(request) {
    return axios
      .post(`/v2/upSertNotification`, request)
      .then(res => {
        return res.data;
      })
  }

  isSSA(moveMaisId) {
    return axios
      .get(`/v1/isSSA/${moveMaisId}`, {})
      .then(res => {
        return res.data;
      })
  }

  getUserByMoveMaisId(moveMaisId){
    return axios.get(`/v2/getUserByMoveMaisId/${moveMaisId}`).then(res => {
        return res.data;
    })
  }

  getUserVpAggregateByPlate(plate){
    return axios.get(`/v2/getUserVpAggregateByPlate/${plate}`).then(res => {
        return res.data;
    })
  }

  buscaEnderecoConveniado(cnpj) {
    return axios.get(`/v2/conveniado/buscaEnderecoConveniado/${cnpj}`).then(res => res.data);
  }

  buscaConveniadosProximos(request) {
    return axios.post(`/v2/conveniado/buscaConveniadosProximos`,request).then(res => res.data);
  }

  getUserAndAddressByTaxIdNumber(taxIdNumber) {
    return axios
      .get(`/v2/getUserAndAddressByTaxIdNumber/${taxIdNumber}`)
      .then((r) => r.data);
  }
  /**
   * Constrói headers de autenticação baseado nos parâmetros fornecidos
   * Suporta três métodos:
   * 1. API Key simples (apenas apiKey)
   * 2. Bearer Token (apenas bearerToken)
   * 3. API Key com assinatura HMAC (apiKey, timestamp, secret)
   *
   * @param {Object} authOptions - Opções de autenticação
   * @param {string} requestPath - Caminho da requisição para assinatura HMAC
   * @param {string} requestBody - Body da requisição para assinatura HMAC
   * @returns {Object} Headers de autenticação
   */
  _buildAuthHeaders(authOptions = {}, requestPath = '', requestBody = '') {
    const headers = {};

    // Método 1: Bearer Token
    if (authOptions.bearerToken) {
      headers['Authorization'] = `Bearer ${authOptions.bearerToken}`;
      return headers;
    }

    // Método 2: API Key com assinatura HMAC
    if (authOptions.apiKey && authOptions.timestamp && authOptions.secret) {
      try {
        const crypto = require('crypto');
        const dataToSign = authOptions.apiKey + authOptions.timestamp + requestPath + requestBody;
        const signature = crypto.createHmac('sha256', authOptions.secret).update(dataToSign).digest('hex');

        headers['X-API-Key'] = authOptions.apiKey;
        headers['X-Timestamp'] = authOptions.timestamp;
        headers['X-Signature'] = signature;
        return headers;
      } catch (e) {
        console.error('Error calculating HMAC:', e);
      }
    }

    // Método 3: API Key simples
    if (authOptions.apiKey) {
      headers['X-API-Key'] = authOptions.apiKey;
      return headers;
    }

    return headers;
  }

  /**
   * Busca usuário e endereço por CPF/CNPJ sem sessão
   *
   * O backend gera o JWT automaticamente usando o CPF passado como parâmetro.
   *
   * @param {string} taxIdNumber - CPF/CNPJ do usuário
   * @returns {Promise<Object>} Dados do usuário e endereço
   */
  getUserAndAddressByTaxIdNumberNoSession(taxIdNumber) {
    // Reutiliza a implementação do AuthService para manter consistência
    const auth = require('./auth').default;
    return auth.getUserAndAddressByTaxIdNumberNoSession(taxIdNumber);
  }


  async getPartnersByPosition(request) {
    const res = await axios.get(`/v2/conveniado/findPartnersByPosition?latitude=${request.latitude}&longitude=${request.longitude}&range=${request.range}`);
    return res.data.partners;
  }

  async getPartnersByCity(city, state, position) {
    const { latitude, longitude } = position;
    const res = await axios.get(`/v2/conveniado/findPartnersByCity?city=${city}&state=${state}&latitude=${latitude}&longitude=${longitude}`);
    return res.data.partners;
  }

  getUserAndAddressByTaxIdNumberAggregate(taxIdNumber) {
    return axios.get(`/v2/getUserAndAddressByTaxIdNumberAggregate/${taxIdNumber}`).then(r => r.data);
  }

  getHorariosParceiros(moveMaisId){
    return axios.get(`/v2/getHorariosParceiros/${moveMaisId}`).then(r => r.data);
  }

  requestChangeUserEmail(taxIdNumber) {
    return axios
      .post('/v2/requestChangeUserEmail',
      {taxIdNumber: taxIdNumber})
      .then(res => {
        return Promise.resolve(true);
      });
  }

  requestChangeUserPhone(taxIdNumber) {
    return axios
      .post('/v2/requestChangeUserPhone',
      {taxIdNumber: taxIdNumber})
      .then(res => {
        return Promise.resolve(true);
      });
  }

}

// Singleton
const instance = new AccountService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/account.js